import { protectedResources } from '@/authConfig';
import { toast } from '@/components/UI/Toast';
import acquireAccessToken from '@/http/Helpers/acquireAccessToken';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { useEffect } from 'react';

import useCurrentUserId from '../hooks/useCurrentUserId';

const NotificationListener = () => {
  const userId = useCurrentUserId();

  useEffect(() => {
    let connection: signalR.HubConnection;

    const setupSignalR = async () => {
      try {
        const accessToken = await acquireAccessToken(
          protectedResources.notificationsWebApi.scopes
        );

        if (!accessToken) {
          console.error('Access token is null or undefined');
          return;
        }

        connection = new HubConnectionBuilder()
          .withUrl(
            `${protectedResources.notificationsWebApi.endpoint}/hub/notifications`,
            {
              accessTokenFactory: () => accessToken,
              withCredentials: false // Disable credentials to avoid CORS issues
            }
          )
          .withAutomaticReconnect()
          .build();

        connection.on('ReceiveNotification', (recipientId, severityId, message) => {
          if (recipientId !== userId) return;

          toast({
            title: 'New notification',
            description: message,
            color: 'info'
          });
        });

        await connection.start();
        console.info('SignalR connected');
      } catch (err) {
        console.error('SignalR connection setup failed:', err);
        // Don't throw the error to prevent app crashes
        // The connection will retry automatically with withAutomaticReconnect()
      }
    };

    setupSignalR();

    return () => {
      if (connection) {
        connection.stop();
      }
    };
  }, [userId]);

  return null;
};

export default NotificationListener;
